import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";

const motivations = [
  {
    ta: "உழைப்பே உயர்வின் முதல் படி",
    en: "Hard work is the first step toward growth"
  },
  {
    ta: "கனவுகள் பெரியதாக இருக்கட்டும், செயல் உறுதியாக இருக்கட்டும்",
    en: "Dream big, act with determination"
  },
  {
    ta: "எதிர்காலம் காத்திருக்காது — அதை உருவாக்கு",
    en: "The future does not wait — create it"
  }
];


const EntrepreneurMotivation = () => {
  return (
    <Box sx={{ py: 8 }}>
      {/* Title */}
      <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          fontWeight: 900,
          mb: 2,
          background: "linear-gradient(45deg, #ff4d4d, #ff8080)",
          WebkitBackgroundClip: "text",
          color: "transparent",
          letterSpacing: "-0.02em"
        }}
      >
        Motivation for Students & Entrepreneurs
      </Typography>

      <Typography
        sx={{
          textAlign: "center",
          mb: 6,
          color: "rgba(255,255,255,0.7)",
          fontSize: "1rem",
          maxWidth: 760,
          mx: "auto",
          lineHeight: 1.7
        }}
      >
        Believe in your dreams. Stay committed to your effort.  
        Your work will define who you become.
      </Typography>

      {/* Motivation Grid */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)"
          },
          gap: 3,
          maxWidth: 1200,
          mx: "auto"
        }}
      >
        {motivations.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: index * 0.04 }}
            viewport={{ once: true }}
          >
            <Card
              sx={{
                height: "100%",
                borderRadius: 3,
                background:
                  "linear-gradient(135deg, rgba(10,17,40,0.95), rgba(26,31,61,0.95))",
                border: "1px solid rgba(255,77,77,0.35)",
                boxShadow: "0 12px 30px rgba(0,0,0,0.45)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 20px 45px rgba(255,77,77,0.35)",
                  borderColor: "#ff4d4d"
                }
              }}
            >
              <CardContent sx={{ p: 3 }}>
                {/* Tamil */}
                <Typography
                  sx={{
                    fontSize: "1rem",
                    color: "rgba(255,255,255,0.95)",
                    lineHeight: 1.8,
                    textAlign: "center",
                    fontWeight: 600,
                    mb: 1
                  }}
                >
                  {item.ta}
                </Typography>

                {/* English */}
                <Typography
                  sx={{
                    fontSize: "0.85rem",
                    color: "rgba(255,255,255,0.65)",
                    lineHeight: 1.6,
                    textAlign: "center",
                    fontStyle: "italic"
                  }}
                >
                  {item.en}
                </Typography>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
};

export default EntrepreneurMotivation;
